export function parseJson(data) {
    try {
      return typeof data === "string" ? JSON.parse(data) : data;
    } catch (error) {
      console.error("JSON parsing error:", error);
      throw error;
    }
  }
